<template>
  <div>
    <van-cell-group class="box" style="padding: 1rem 0;text-align: left;color: #666;">
      <van-row type="flex">
        <div style="padding:0 1rem;padding-top: 1rem;">
          <van-image
            round
            width="5rem"
            height="5rem"
            fit="cover"
            :src=headimg
          />
        </div>
        <div style="margin-left: 0.1rem;">
          <van-row><p v-if="!showIccid"></p><label v-if="showIccid">ICCID：{{iccid}}</label></van-row>
          <van-row>
            <label>卡号：{{serial}}</label>
          </van-row>
          <van-row><label>实名：{{certification}}</label></van-row>
          <van-row><label>状态：</label><van-tag round size="medium" :type="type">{{status}}</van-tag></van-row>
        </div>
        <div style="position:absolute;right: 0;">
          <label><van-icon name="wap-home" size="1.7rem" style="margin: 0 1rem" v-on:click="home()"/></label>
        </div>
      </van-row>
    </van-cell-group>
    <div v-show="notice">
      <van-notice-bar
        text="有效期不足5天将停机，请提前充值！"
        left-icon="info-o"
        mode="closeable"
      />
    </div>
  </div>
</template>

<script>
import { cardInfo } from '../api/card'
import { Toast } from 'vant'
import store from '../../store'
export default {
  name: 'Dashboard',
  data () {
    return {
      notice: false,
      showIccid: false,
      iccid: '',
      serial: '',
      certification: '未实名',
      status: '未激活',
      type: 'primary',
      headimg: require('@/assets/image/cucc.png')
    }
  },
  methods: {
    queryCardInfo: function (iccid) {
      cardInfo({'cn': iccid}).then(res => {
        Toast.clear()
        res = res.data
        if (res.data.day <= 6) {
          this.notice = true
        }
        store.dispatch('user/setCerUrl', res.data.certification_url)
        store.commit('user/SET_CER_URL', res.data.certification_url)
        if (res.data.operator === '中国联通' || res.data.operator === 'CUCC') {
          this.iccid = res.data.iccid.slice(0, 19)
        } else {
          this.iccid = res.data.iccid
        }
        this.showIccid = res.data.show_iccid
        this.serial = res.data.serial
        this.certification = res.data.certification === 1 ? '已实名' : '未实名'
        if (res.data.info) {
          switch (res.data.info.status) {
            case 0:
              this.status = '未激活'
              this.type = 'primary'
              break
            case 1:
              this.status = '已激活'
              this.type = 'success'
              break
            case 2:
              this.status = '已停用'
              this.type = 'danger'
              break
            case 3:
              this.status = '已激活'
              this.type = 'success'
              break
          }
        }
        switch (res.data.operator) {
          case '中国联通':
            this.headimg = require('@/assets/image/cucc.png')
            break
          case '中国移动':
            this.headimg = require('@/assets/image/ctcc.png')
            break
          case '中国电信':
            this.headimg = require('@/assets/image/cmcc.png')
            break
        }
      })
    },
    home: function () {
      this.$router.push({ path: '/home' })
    }
  },
  mounted () {
    // we can implement any method here like
    this.queryCardInfo(this.$route.params.iccid)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label{
  color: #fff;
  line-height: 1.8rem;
  font-size: 0.8rem;
}
.box{
  background: -webkit-linear-gradient(right, red , blue); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, red, blue); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, red, blue); /* Firefox 3.6 - 15 */
  background: linear-gradient(right, #51a4de , #61c4c7); /* 标准的语法（必须放在最后） */
}
</style>



// WEBPACK FOOTER //
// src/card/views/Header.vue